import { Signal } from '@angular/core';

import { AnalyticsBase } from '@core/analytics-legacy';
import { BadgeColor, IconName, RtButtonVariant } from '@core/user-interface-legacy';

import { TellentBrand } from '../../index';

export type TellentAppCopy = {
  name: string;
  type: string;
  description: string | string[];
  badge?: TellentAppBadge | TellentAppBadge[];
};

export type TellentAppBadge = { text: string; color: BadgeColor; icon?: IconName };

export type TellentAppAction = {
  handler: () => void;
  label: string;
  variant: RtButtonVariant;
  description?: string;
  analytics?: string;
  disabled?: boolean;
};

export type TellentApp = {
  brand: TellentBrand;
  copy: TellentAppCopy;
  action: TellentAppAction;
  isActive: boolean;
};

type BillingProductsSectionAction = 'start_trial' | 'choose_plan' | 'change_plan' | 'contact_us';

export abstract class ManageAppsAnalytics extends AnalyticsBase {
  public abstract trackServiceSelected(
    action: BillingProductsSectionAction,
    app: TellentBrand,
  ): void;
}

export abstract class ManageAppsService {
  public abstract readonly viewModels: Signal<TellentApp[]>;
  public abstract readonly isLoaded: Signal<boolean>;
}
